// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"157aa668","453":"7eba331d","985":"69e38827"}[chunkId] + ".chunk.js";
};